import React from 'react';
import Modal from './Modal';

const AboutModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="About VaultZip">
      <div className="about-content">
        <div className="about-intro">
          <p>
            <strong>VaultZip</strong> helps you securely archive and encrypt files directly in your
            browser. No files or passwords are sent to a server — everything runs locally on your
            device.
          </p>
        </div>

        <div className="about-section">
          <h3>🔒 How it works</h3>
          <ul>
            <li>Select files or folders, or drag & drop them into the upload area</li>
            <li>Choose a strong password and create a password‑protected ZIP archive</li>
            <li>Download the encrypted archive instantly</li>
            <li>
              <strong>Important:</strong> Keep your password safe — recovery is impossible without
              it
            </li>
          </ul>
        </div>

        <div className="about-section">
          <h3>🛡️ Privacy & Security</h3>
          <ul>
            <li>Until you save the result, all files live only in the browser memory.</li>
            <li>All processing happens locally in your browser using Web Crypto API</li>
            <li>We do not store, transmit, or log your files or passwords</li>
            <li>No network requests are made during encryption/decryption</li>
            <li>Your data never leaves your device</li>
          </ul>
        </div>

        <div className="about-section">
          <h3>⚡ Features</h3>
          <ul>
            <li>AES-256 encryption for maximum security</li>
            <li>Support for files and folders (with structure preservation)</li>
            <li>Compression level selection (fast, balanced, maximum)</li>
            <li>Optional README file inclusion</li>
            <li>Password strength indicator</li>
            <li>Drag & drop support</li>
            <li>Advanced password generator with customizable options</li>
          </ul>
        </div>

        <div className="about-section">
          <h3>📊 Compression Levels Explained</h3>
          <div className="compression-details">
            <div className="compression-item">
              <h4>⚡ Fast (Level 1)</h4>
              <ul>
                <li>
                  <strong>Speed:</strong> Maximum (very fast)
                </li>
                <li>
                  <strong>File size:</strong> Larger (minimal compression)
                </li>
                <li>
                  <strong>Best for:</strong> Large files, already compressed formats (JPG, MP4, MP3),
                  when speed is critical
                </li>
              </ul>
            </div>

            <div className="compression-item recommended">
              <h4>⚖️ Balanced (Level 6) ⭐ Recommended</h4>
              <ul>
                <li>
                  <strong>Speed:</strong> Medium (optimal)
                </li>
                <li>
                  <strong>File size:</strong> Medium (good compression)
                </li>
                <li>
                  <strong>Best for:</strong> Most use cases, mixed file types, optimal balance
                  between speed and size
                </li>
              </ul>
            </div>

            <div className="compression-item">
              <h4>📦 Maximum (Level 9)</h4>
              <ul>
                <li>
                  <strong>Speed:</strong> Slow (takes more time)
                </li>
                <li>
                  <strong>File size:</strong> Smallest (maximum compression)
                </li>
                <li>
                  <strong>Best for:</strong> Text files, documents, when minimum size is needed,
                  time is not critical
                </li>
              </ul>
            </div>

            <div className="compression-example">
              <p>
                <strong>💡 Example:</strong> 100 MB of text documents:
              </p>
              <ul>
                <li>Level 1: ~95 MB (5% compression) in 2 seconds</li>
                <li>Level 6: ~30 MB (70% compression) in 5 seconds ⭐</li>
                <li>Level 9: ~25 MB (75% compression) in 15 seconds</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="about-footer">
          <p className="muted">
            <small>
              Built with ❤️ using React, JSZip, and modern web standards. Open source and free to
              use.
            </small>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default AboutModal;
